/**
 * Approval checkboxes
 */
(() => {
  const approvalPage = document.querySelector('.ex-awaiting-approvals');
  if (!approvalPage) return;

  const orderGrid = approvalPage.querySelector('#ordergrid');
  if (!orderGrid) return;

  /**
   * Add checkboxes to all rows that are not rejected
   */
  orderGrid.querySelectorAll('tbody tr').forEach((row) => {
    // Check if the row has a "Rejected" status
    const statusSpan = row.querySelector('td.status .content_value > span');
    if (statusSpan && statusSpan.innerHTML.trim() === 'Rejected') {
      return; // Skip this row
    }

    const approvalCheckbox = document.createElement('td');
    approvalCheckbox.classList.add('approval-checkbox');
    approvalCheckbox.innerHTML = '<input type="checkbox" class="check" />';

    row.append(approvalCheckbox);
  });

  // Add header checkbox to select all
  const thead = orderGrid.querySelector('thead tr');
  if (thead) {
    const headerCheckbox = document.createElement('th');
    headerCheckbox.classList.add('approval-checkbox-header');
    headerCheckbox.innerHTML = '<input type="checkbox" class="check-all" />';
    thead.appendChild(headerCheckbox);
  }

  /**
   * Add approval/rejection buttons
   */
  const approvalButtonsDiv = document.createElement('div');
  approvalButtonsDiv.classList.add('approval-buttons', 'hide');

  const approvalButton = document.createElement('button');
  approvalButton.classList.add('approval-button');
  approvalButton.innerHTML = 'Approve Selected';
  approvalButton.classList.add('btn', 'btn-primary');
  approvalButtonsDiv.append(approvalButton);

  const rejectButton = document.createElement('button');
  rejectButton.classList.add('reject-button');
  rejectButton.innerHTML = 'Reject Selected';
  rejectButton.classList.add('btn', 'btn-danger');
  approvalButtonsDiv.append(rejectButton);

  orderGrid.before(approvalButtonsDiv);

  /**
   * Update button visibility
   */
  const approvalBtnVisible = () => {
    const checkedCheckboxes = orderGrid.querySelectorAll('input.check:checked');
    const count = checkedCheckboxes.length;
    if (count > 0) {
      approvalButtonsDiv.classList.remove('hide');
      approvalButton.innerHTML = `Approve (${count}) Selected Orders`;
      rejectButton.innerHTML = `Reject (${count}) Selected Orders`;
    } else {
      approvalButtonsDiv.classList.add('hide');
    }
  };

  // Trigger approval button visibility when a checkbox is changed
  orderGrid.addEventListener('change', (event) => {
    if (event.target.classList.contains('check')) {
      approvalBtnVisible();
    }
  });

  /**
   * Approval Button Functionality
   */
  approvalButton.addEventListener('click', () => {
    const selectedCheckboxes = orderGrid.querySelectorAll('input.check:checked');
    const promises = [];
    const count = selectedCheckboxes.length;

    selectedCheckboxes.forEach((checkbox) => {
      const closestApproveOrder = checkbox.closest('tr').querySelector('a.approve-order');
      if (closestApproveOrder) {
        const quoteId = closestApproveOrder.getAttribute('data-quoteid');
        console.log('Clicking approve order for:', quoteId);

        const promise = $.ajax({
          type: 'post',
          url: `/api/orders/approve/${quoteId}`,
          headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
          },
          error(err) {
            console.error('AJAX Error:', err);
          },
        });

        promises.push(promise);
      }
    });

    approvalButton.disabled = true;
    rejectButton.disabled = true;

    approvalButton.innerHTML = `Approving (${count}) Orders...`;

    // Wait for all AJAX requests to complete, then refresh
    Promise.all(promises).then(() => {
      window.location.reload();
    }).catch((error) => {
      console.error('Some approvals failed:', error);
      window.location.reload();
    });
  });

  /**
   * Rejection Button Functionality
   */
  rejectButton.addEventListener('click', () => {
    const selectedCheckboxes = orderGrid.querySelectorAll('input.check:checked');
    const promises = [];
    const count = selectedCheckboxes.length;

    selectedCheckboxes.forEach((checkbox) => {
      const closestApproveOrder = checkbox.closest('tr').querySelector('a.approve-order');
      if (closestApproveOrder) {
        const quoteId = closestApproveOrder.getAttribute('data-quoteid');
        console.log('Clicking reject order for:', quoteId);

        const promise = $.ajax({
          type: 'post',
          url: `/api/orders/reject/${quoteId}`,
          headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
          },
          error(err) {
            console.error('AJAX Error:', err);
          },
        });

        promises.push(promise);
      }
    });

    approvalButton.disabled = true;
    rejectButton.disabled = true;

    rejectButton.innerHTML = `Rejecting (${count}) Orders...`;

    // Wait for all AJAX requests to complete, then refresh
    Promise.all(promises).then(() => {
      window.location.reload();
    }).catch((error) => {
      console.error('Some rejections failed:', error);
      window.location.reload();
    });
  });

  /**
   * Select All Checkbox Functionality
   */
  const selectAllCheckbox = orderGrid.querySelector('input.check-all');
  if (selectAllCheckbox) {
    selectAllCheckbox.addEventListener('change', (event) => {
      const isChecked = event.target.checked;
      const allCheckboxes = orderGrid.querySelectorAll('tbody input.check');

      allCheckboxes.forEach((checkbox) => {
        checkbox.checked = isChecked;
      });

      approvalBtnVisible();
    });
  }
})();
